// Role of this file:
// Listen for an action
// produce a side effect which is communicate with the server via http,
// bring data back and dispatch a new action (success or fail)

import { Injectable } from "@angular/core";

// Actions is an observable that listens to the types of actions
// being dispatched and we can respond accordingly
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";

import { WarningDialogComponent } from "#core/components/content-library/assign-cart/components/warning-dialog/warning-dialog.component";
import { SnackBarService } from "#services/snackbar.service";
import { MatDialog } from "@angular/material/dialog";
import { AssignmentsService } from "@carnegie-learning/data-access-angular-passport";
import * as assignActions from "../actions/selected-students.action";

@Injectable()
export class SelectedAssignablesEffects {
    working = false;

    constructor(
        private actions$: Actions,
        private snackBarService: SnackBarService,
        private assignmentsService: AssignmentsService,
        public dialog: MatDialog
    ) {}

    assign$ = createEffect(() =>
        this.actions$.pipe(ofType(assignActions.assign)).pipe(
            map((action) => action.payload),
            mergeMap((assignment) => {
                this.working = true;
                if (this.working) {
                    this.snackBarService.working("Working...");
                }
                return this.assignmentsService
                    .createAssignments(assignment.assets, assignment.students)
                    .pipe(
                        map((response) => {
                            this.working = false;
                            this.snackBarService.success(
                                "Successfully Assigned!"
                            );
                            return assignActions.assignSuccess({
                                payload: response,
                            });
                        }),
                        catchError((error) => {
                            this.working = false;
                            if (error.error.hasOwnProperty("case")) {
                                this.snackBarService.success(
                                    "Successfully Assigned!"
                                );
                                const dialogRef = this.dialog.open(
                                    WarningDialogComponent,
                                    {
                                        width: "40vw",
                                        maxWidth: "700px",
                                        minWidth: "300px",
                                        data: {
                                            msg: error.error.message,
                                            case: error.error.case,
                                        },
                                    }
                                );
                            } else {
                                this.snackBarService.success(
                                    "Failed To Assign!"
                                );
                            }

                            return of(
                                assignActions.assignFail({ payload: error })
                            );
                        })
                    );
            })
        )
    );
}
